import { render, staticRenderFns } from "./ProjectChatCard.vue?vue&type=template&id=5fbdbaa7&scoped=true"
import script from "./ProjectChatCard.vue?vue&type=script&lang=js"
export * from "./ProjectChatCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectChatCard.vue?vue&type=style&index=0&id=5fbdbaa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbdbaa7",
  null
  
)

export default component.exports